import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import QuickWisdom from "./QuickWisdom";
import DeepReflections from "./DeepReflections";
import PersonalStories from "./PersonalStories";

function Philosophy() {
    const [contentData, setContentData] = useState({
        quotes: [],
        deepThoughts: [],
        personalStories: []
    });

    useEffect(() => {
        // Load all JSON data for navigation
        const quotes = require("../../Assets/quotes.json");
        const deepThoughts = require("../../Assets/deep-thoughts.json");
        const personalStories = require("../../Assets/personal-stories.json");

        setContentData({
            quotes: quotes,
            deepThoughts: deepThoughts,
            personalStories: personalStories
        });
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const scrollToSpecificItem = (sectionId, itemIndex) => {
        // Since we're now showing items in the same order as the components,
        // we can use the index directly
        const element = document.getElementById(`${sectionId}-item-${itemIndex}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // Add a brief highlight effect
            element.style.transition = 'all 0.3s ease';
            element.style.transform = 'scale(1.02)';
            element.style.boxShadow = '0 8px 25px rgba(199, 112, 240, 0.3)';
            setTimeout(() => {
                element.style.transform = 'scale(1)';
                element.style.boxShadow = '';
            }, 800);
        }
    }; return (
        <Container fluid className="about-section">
            <Container>
                <Row style={{ justifyContent: "center", padding: "10px" }}>
                    <Col
                        md={12}
                        style={{
                            justifyContent: "center",
                            paddingTop: "30px",
                            paddingBottom: "30px",
                        }}
                    >
                        <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                            My <strong className="purple">Philosophy</strong>
                        </h1>
                        <p style={{ textAlign: "center", fontSize: "1.2em", paddingBottom: "40px" }}>
                            A collection of my thoughts, wisdom, and reflections on life, growth, and the pursuit of understanding.
                        </p>
                    </Col>
                </Row>

                {/* Clean Table of Contents */}
                <Row style={{ justifyContent: "center", paddingBottom: "60px" }}>
                    <Col md={10}>
                        <div style={{
                            textAlign: 'center',
                            marginBottom: '40px'
                        }}>
                            <h2 style={{
                                fontSize: '2.2em',
                                color: '#c770f0',
                                fontWeight: 'bold',
                                marginBottom: '15px',
                                textShadow: '0 0 20px rgba(199, 112, 240, 0.3)'
                            }}>
                                Table of Contents
                            </h2>
                            <p style={{
                                fontSize: '1.1em',
                                color: 'rgba(255,255,255,0.8)',
                                marginBottom: '35px'
                            }}>
                                Explore my thoughts, reflections, and stories
                            </p>
                        </div>

                        <Row style={{ justifyContent: "center" }}>
                            {/* Deep Reflections Navigation */}
                            <Col md={4} style={{ marginBottom: "30px" }}>
                                <Card style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(199, 112, 240, 0.3)',
                                    borderRadius: '15px',
                                    backdropFilter: 'blur(10px)',
                                    transition: 'all 0.3s ease',
                                    height: '100%'
                                }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(199, 112, 240, 0.2)';
                                        e.currentTarget.style.borderColor = 'rgba(199, 112, 240, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.borderColor = 'rgba(199, 112, 240, 0.3)';
                                    }}
                                >
                                    <Card.Body style={{ padding: '25px' }}>
                                        <div style={{
                                            textAlign: 'center',
                                            marginBottom: '20px'
                                        }}>
                                            <h4 style={{
                                                color: '#c770f0',
                                                fontWeight: 'bold',
                                                marginBottom: '10px'
                                            }}>
                                                Deep Reflections
                                            </h4>
                                            <p style={{
                                                color: 'rgba(255,255,255,0.7)',
                                                fontSize: '0.9em',
                                                marginBottom: '15px'
                                            }}>
                                                {contentData.deepThoughts.length} contemplations to explore
                                            </p>
                                            <button
                                                onClick={() => scrollToSection('deep-reflections')}
                                                style={{
                                                    background: 'linear-gradient(45deg, #c770f0, #9b7eac)',
                                                    border: 'none',
                                                    borderRadius: '25px',
                                                    color: 'white',
                                                    padding: '8px 20px',
                                                    fontSize: '0.9em',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'scale(1.05)';
                                                    e.target.style.boxShadow = '0 5px 15px rgba(199, 112, 240, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'scale(1)';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            >
                                                View All Reflections
                                            </button>
                                        </div>

                                        <div style={{
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            paddingRight: '5px'
                                        }}>
                                            {contentData.deepThoughts.map((thought, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => scrollToSpecificItem('deep-reflections', index)}
                                                    style={{
                                                        padding: '10px 15px',
                                                        margin: '8px 0',
                                                        borderRadius: '10px',
                                                        cursor: 'pointer',
                                                        fontSize: '0.9em',
                                                        fontWeight: '500',
                                                        color: '#c770f0',
                                                        background: 'rgba(199, 112, 240, 0.08)',
                                                        border: '1px solid rgba(199, 112, 240, 0.2)',
                                                        transition: 'all 0.3s ease',
                                                        position: 'relative',
                                                        overflow: 'hidden'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = 'rgba(199, 112, 240, 0.15)';
                                                        e.target.style.borderColor = 'rgba(199, 112, 240, 0.4)';
                                                        e.target.style.color = '#ffffff';
                                                        e.target.style.transform = 'translateX(5px)';
                                                        e.target.style.boxShadow = '0 4px 15px rgba(199, 112, 240, 0.2)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = 'rgba(199, 112, 240, 0.08)';
                                                        e.target.style.borderColor = 'rgba(199, 112, 240, 0.2)';
                                                        e.target.style.color = '#c770f0';
                                                        e.target.style.transform = 'translateX(0)';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                >
                                                    <span style={{
                                                        fontWeight: 'bold',
                                                        marginRight: '8px',
                                                        color: 'rgba(199, 112, 240, 0.8)'
                                                    }}>
                                                        {index + 1}.
                                                    </span>
                                                    {thought.title}
                                                </div>
                                            ))}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            {/* Quick Wisdom Navigation */}
                            <Col md={4} style={{ marginBottom: "30px" }}>
                                <Card style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(199, 112, 240, 0.3)',
                                    borderRadius: '15px',
                                    backdropFilter: 'blur(10px)',
                                    transition: 'all 0.3s ease',
                                    height: '100%'
                                }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(199, 112, 240, 0.2)';
                                        e.currentTarget.style.borderColor = 'rgba(199, 112, 240, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.borderColor = 'rgba(199, 112, 240, 0.3)';
                                    }}
                                >
                                    <Card.Body style={{ padding: '25px' }}>
                                        <div style={{
                                            textAlign: 'center',
                                            marginBottom: '20px'
                                        }}>
                                            <h4 style={{
                                                color: '#c770f0',
                                                fontWeight: 'bold',
                                                marginBottom: '10px'
                                            }}>
                                                Quick Wisdom
                                            </h4>
                                            <p style={{
                                                color: 'rgba(255,255,255,0.7)',
                                                fontSize: '0.9em',
                                                marginBottom: '15px'
                                            }}>
                                                {contentData.quotes.length} insights to explore
                                            </p>
                                            <button
                                                onClick={() => scrollToSection('quick-wisdom')}
                                                style={{
                                                    background: 'linear-gradient(45deg, #c770f0, #9b7eac)',
                                                    border: 'none',
                                                    borderRadius: '25px',
                                                    color: 'white',
                                                    padding: '8px 20px',
                                                    fontSize: '0.9em',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'scale(1.05)';
                                                    e.target.style.boxShadow = '0 5px 15px rgba(199, 112, 240, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'scale(1)';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            >
                                                View All Insights
                                            </button>
                                        </div>

                                        <div style={{
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            paddingRight: '5px'
                                        }}>
                                            {contentData.quotes.map((quote, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => scrollToSpecificItem('quick-wisdom', index)}
                                                    style={{
                                                        padding: '10px 15px',
                                                        margin: '8px 0',
                                                        borderRadius: '10px',
                                                        cursor: 'pointer',
                                                        fontSize: '0.9em',
                                                        fontWeight: '500',
                                                        color: '#c770f0',
                                                        background: 'rgba(199, 112, 240, 0.08)',
                                                        border: '1px solid rgba(199, 112, 240, 0.2)',
                                                        transition: 'all 0.3s ease',
                                                        position: 'relative',
                                                        overflow: 'hidden'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = 'rgba(199, 112, 240, 0.15)';
                                                        e.target.style.borderColor = 'rgba(199, 112, 240, 0.4)';
                                                        e.target.style.color = '#ffffff';
                                                        e.target.style.transform = 'translateX(5px)';
                                                        e.target.style.boxShadow = '0 4px 15px rgba(199, 112, 240, 0.2)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = 'rgba(199, 112, 240, 0.08)';
                                                        e.target.style.borderColor = 'rgba(199, 112, 240, 0.2)';
                                                        e.target.style.color = '#c770f0';
                                                        e.target.style.transform = 'translateX(0)';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                >
                                                    <span style={{
                                                        fontWeight: 'bold',
                                                        marginRight: '8px',
                                                        color: 'rgba(199, 112, 240, 0.8)'
                                                    }}>
                                                        {index + 1}.
                                                    </span>
                                                    {quote.title}
                                                </div>
                                            ))}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            {/* Personal Stories Navigation */}
                            <Col md={4} style={{ marginBottom: "30px" }}>
                                <Card style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(199, 112, 240, 0.3)',
                                    borderRadius: '15px',
                                    backdropFilter: 'blur(10px)',
                                    transition: 'all 0.3s ease',
                                    height: '100%'
                                }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(199, 112, 240, 0.2)';
                                        e.currentTarget.style.borderColor = 'rgba(199, 112, 240, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.borderColor = 'rgba(199, 112, 240, 0.3)';
                                    }}
                                >
                                    <Card.Body style={{ padding: '25px' }}>
                                        <div style={{
                                            textAlign: 'center',
                                            marginBottom: '20px'
                                        }}>
                                            <h4 style={{
                                                color: '#c770f0',
                                                fontWeight: 'bold',
                                                marginBottom: '10px'
                                            }}>
                                                Personal Stories
                                            </h4>
                                            <p style={{
                                                color: 'rgba(255,255,255,0.7)',
                                                fontSize: '0.9em',
                                                marginBottom: '15px'
                                            }}>
                                                {contentData.personalStories.length} stories to explore
                                            </p>
                                            <button
                                                onClick={() => scrollToSection('personal-stories')}
                                                style={{
                                                    background: 'linear-gradient(45deg, #c770f0, #9b7eac)',
                                                    border: 'none',
                                                    borderRadius: '25px',
                                                    color: 'white',
                                                    padding: '8px 20px',
                                                    fontSize: '0.9em',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'scale(1.05)';
                                                    e.target.style.boxShadow = '0 5px 15px rgba(199, 112, 240, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'scale(1)';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            >
                                                View All Stories
                                            </button>
                                        </div>

                                        <div style={{
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            paddingRight: '5px'
                                        }}>
                                            {contentData.personalStories.map((story, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => scrollToSpecificItem('personal-stories', index)}
                                                    style={{
                                                        padding: '10px 15px',
                                                        margin: '8px 0',
                                                        borderRadius: '10px',
                                                        cursor: 'pointer',
                                                        fontSize: '0.9em',
                                                        fontWeight: '500',
                                                        color: '#c770f0',
                                                        background: 'rgba(199, 112, 240, 0.08)',
                                                        border: '1px solid rgba(199, 112, 240, 0.2)',
                                                        transition: 'all 0.3s ease',
                                                        position: 'relative',
                                                        overflow: 'hidden'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = 'rgba(199, 112, 240, 0.15)';
                                                        e.target.style.borderColor = 'rgba(199, 112, 240, 0.4)';
                                                        e.target.style.color = '#ffffff';
                                                        e.target.style.transform = 'translateX(5px)';
                                                        e.target.style.boxShadow = '0 4px 15px rgba(199, 112, 240, 0.2)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = 'rgba(199, 112, 240, 0.08)';
                                                        e.target.style.borderColor = 'rgba(199, 112, 240, 0.2)';
                                                        e.target.style.color = '#c770f0';
                                                        e.target.style.transform = 'translateX(0)';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                >
                                                    <span style={{
                                                        fontWeight: 'bold',
                                                        marginRight: '8px',
                                                        color: 'rgba(199, 112, 240, 0.8)'
                                                    }}>
                                                        {index + 1}.
                                                    </span>
                                                    {story.title}
                                                </div>
                                            ))}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/* Deep Reflections Section */}
                <Row id="deep-reflections" style={{ justifyContent: "center", paddingBottom: "50px" }}>
                    <Col md={12}>
                        <h2 className="project-heading" style={{ paddingBottom: "20px" }}>
                            Deep <strong className="purple">Reflections</strong>
                        </h2>
                        <p style={{ color: "white", textAlign: "center", paddingBottom: "30px" }}>
                            Longer contemplations on life, purpose, and personal growth.
                        </p>
                        <DeepReflections />
                    </Col>
                </Row>

                {/* Quick Wisdom Section */}
                <Row id="quick-wisdom" style={{ justifyContent: "center", paddingBottom: "50px" }}>
                    <Col md={12}>
                        <h2 className="project-heading" style={{ paddingBottom: "20px" }}>
                            Quick <strong className="purple">Wisdom</strong>
                        </h2>
                        <p style={{ color: "white", textAlign: "center", paddingBottom: "30px" }}>
                            Short, powerful insights and observations from my journey.
                        </p>
                        <QuickWisdom />
                    </Col>
                </Row>

                {/* Personal Stories Section */}
                <Row id="personal-stories" style={{ justifyContent: "center", paddingBottom: "50px" }}>
                    <Col md={12}>
                        <h2 className="project-heading" style={{ paddingBottom: "20px" }}>
                            Personal <strong className="purple">Stories</strong>
                        </h2>
                        <p style={{ color: "white", textAlign: "center", paddingBottom: "30px" }}>
                            Experiences and stories that have shaped my perspective and philosophy.
                        </p>
                        <PersonalStories />
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Philosophy;
